import React from 'react'

interface FlagIconProps {
  code: string
  className?: string
  alt?: string
}

export const FlagIcon: React.FC<FlagIconProps> = ({
  code,
  className = 'w-5 h-5',
  alt,
}) => {
  const normalized = code.toLowerCase().replace('_', '-')

  if (normalized === 'en') {
    return (
      <img
        src="/assets/images/flag-en-682593.png"
        alt={alt || 'English'}
        className={`${className} rounded-full object-cover shrink-0`}
      />
    )
  }

  // German Flag (DE)
  if (normalized === 'de') {
    return (
      <svg
        viewBox="0 0 32 32"
        className={`${className} rounded-full overflow-hidden shrink-0 shadow-[0_0_0_1px_rgba(0,0,0,0.08)]`}
        aria-label={alt || 'German'}
      >
        <rect width="32" height="10.67" fill="#1C1C1C" />
        <rect y="10.67" width="32" height="10.67" fill="#DD0000" />
        <rect y="21.33" width="32" height="10.67" fill="#FFCE00" />
      </svg>
    )
  }

  // French Flag (FR)
  if (normalized === 'fr') {
    return (
      <svg
        viewBox="0 0 32 32"
        className={`${className} rounded-full overflow-hidden shrink-0 shadow-[0_0_0_1px_rgba(0,0,0,0.08)]`}
        aria-label={alt || 'French'}
      >
        <rect width="10.67" height="32" fill="#002654" />
        <rect x="10.67" width="10.67" height="32" fill="#FFFFFF" />
        <rect x="21.33" width="10.67" height="32" fill="#ED2939" />
      </svg>
    )
  }

  // Italian Flag (IT)
  if (normalized === 'it') {
    return (
      <svg
        viewBox="0 0 32 32"
        className={`${className} rounded-full overflow-hidden shrink-0 shadow-[0_0_0_1px_rgba(0,0,0,0.08)]`}
        aria-label={alt || 'Italian'}
      >
        <rect width="10.67" height="32" fill="#009246" />
        <rect x="10.67" width="10.67" height="32" fill="#FFFFFF" />
        <rect x="21.33" width="10.67" height="32" fill="#CE2B37" />
      </svg>
    )
  }

  // Dutch Flag (NL)
  if (normalized === 'nl') {
    return (
      <svg
        viewBox="0 0 32 32"
        className={`${className} rounded-full overflow-hidden shrink-0 shadow-[0_0_0_1px_rgba(0,0,0,0.08)]`}
        aria-label={alt || 'Dutch'}
      >
        <rect width="32" height="10.67" fill="#AE1C28" />
        <rect y="10.67" width="32" height="10.67" fill="#FFFFFF" />
        <rect y="21.33" width="32" height="10.67" fill="#21468B" />
      </svg>
    )
  }

  // Spanish Flag (ES)
  if (normalized === 'es') {
    return (
      <svg
        viewBox="0 0 32 32"
        className={`${className} rounded-full overflow-hidden shrink-0 shadow-[0_0_0_1px_rgba(0,0,0,0.08)]`}
        aria-label={alt || 'Spanish'}
      >
        <rect width="32" height="8" fill="#AA151B" />
        <rect y="8" width="32" height="16" fill="#F1BF00" />
        <rect y="24" width="32" height="8" fill="#AA151B" />
        <circle cx="10" cy="16" r="3" fill="#AA151B" opacity="0.65" />
      </svg>
    )
  }

  // Chinese Flag (ZH / ZH-CN)
  if (normalized === 'zh' || normalized === 'zh-cn') {
    return (
      <svg
        viewBox="0 0 32 32"
        className={`${className} rounded-full overflow-hidden shrink-0 shadow-[0_0_0_1px_rgba(0,0,0,0.08)]`}
        aria-label={alt || 'Chinese'}
      >
        <rect width="32" height="32" fill="#DE2910" />
        {/* Large Star */}
        <polygon
          points="8,4.5 9.2,8.2 13.1,8.2 10,10.5 11.2,14.2 8,11.9 4.8,14.2 6,10.5 2.9,8.2 6.8,8.2"
          fill="#FFDE00"
        />
        {/* Small stars */}
        <polygon
          points="16,4 16.5,5.5 18,5.5 16.8,6.4 17.2,7.9 16,7 14.8,7.9 15.2,6.4 14,5.5 15.5,5.5"
          fill="#FFDE00"
          transform="scale(0.85) translate(4, 0)"
        />
        <polygon
          points="18.5,8 19,9.5 20.5,9.5 19.3,10.4 19.7,11.9 18.5,11 17.3,11.9 17.7,10.4 16.5,9.5 18,9.5"
          fill="#FFDE00"
          transform="scale(0.85) translate(3.5, 0.5)"
        />
        <polygon
          points="18.5,13.5 19,15 20.5,15 19.3,15.9 19.7,17.4 18.5,16.5 17.3,17.4 17.7,15.9 16.5,15 18,15"
          fill="#FFDE00"
          transform="scale(0.85) translate(3.5, 0.5)"
        />
        <polygon
          points="16,17.5 16.5,19 18,19 16.8,19.9 17.2,21.4 16,20.5 14.8,21.4 15.2,19.9 14,19 15.5,19"
          fill="#FFDE00"
          transform="scale(0.85) translate(4, 0.5)"
        />
      </svg>
    )
  }

  // Fallback
  return (
    <span
      className={`${className} rounded-full bg-slate-200 text-[10px] font-bold uppercase flex items-center justify-center text-slate-700`}
    >
      {code.slice(0, 2)}
    </span>
  )
}

export default FlagIcon
